import React, { useState, useEffect, useCallback } from "react";
import MoneyIcon from "../icons/MoneyIcon";
import { useTranslationContext } from "../context/TranslationsProvider";
import debounce from "lodash/debounce";

const MontoInput = ({ monto, setMonto, mensajePlazo, limites }) => {
    const [touched, setTouched] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const { translations } = useTranslationContext();
    const t = (key, fallback) => translations[key] || fallback;

    useEffect(() => {
        if (monto !== inputValue) {
            setInputValue(monto || '');
            if (!monto) {
                setTouched(false);
            }
        }
    }, [monto]);

    const debouncedSetMonto = useCallback(
        debounce((value) => {
            setMonto(value);
        }, 500),
        [setMonto]
    );

    const handleChange = (e) => {
        const raw = e.target.value.replace(/\D/g, "");
        setInputValue(raw);
        debouncedSetMonto(raw);
        setTouched(true);
    };

    const formatoCOP = new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0
    });

    const isValid = monto && !mensajePlazo && touched;

    const displayValue = isFocused 
        ? inputValue 
        : inputValue 
            ? formatoCOP.format(Number(inputValue))
            : '';

    return (
        <div className="monto-input-container">
            <label className="monto-label">
                {t('bdo-libranza-label-amount', '¿Cuánto dinero necesitas?')}
            </label>
            <div 
                className="monto-input-wrapper"
                style={{
                    border: isValid ? '2px solid var(--color-success)' : '1px solid var(--color-border)',
                    borderRadius: '10px',
                    transition: 'border-color 0.2s ease'
                }}
            >
                <div className="monto-icon-wrapper">
                    <MoneyIcon />
                </div>
                <input
                    type="text"
                    value={displayValue}
                    onChange={handleChange}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => {
                        setIsFocused(false);
                        setTouched(true);
                    }}
                    className="monto-input"
                    placeholder={t('bdo-libranza-placeholder-amount', 'Ingresa el monto')}
                    style={{
                        border: 'none',
                        outline: 'none'
                    }}
                />
            </div>

            <p className="monto-helper">
                {t('bdo-libranza-helper-amount', 'Desde')} {formatoCOP.format(limites?.min || 500000)}
            </p>

            {touched && mensajePlazo && (
                <p className="monto-error">{mensajePlazo}</p>
            )}
        </div>
    );
};

export default MontoInput;
